module.exports = __webpack_public_path__ + "static/media/loading.a3980ca4.gif";